import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrPartnerSection = ({
  title,
  headerRow,
  children,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <div className='SrPartnerSection'>
      <div className='flex' style={{ position: 'relative' }}>
        <SrBox marginRight={isSmallScreen ? '25px' : null}>
          <SrText
            font='greycliff'
            weight='800'
            fontSize='28px'
            lineHeight='34px'
          >
            {title}
          </SrText>
        </SrBox>
        {headerRow}
      </div>
      <div className='sectionContent'>
        {children}
      </div>
    </div>
  );
};

SrPartnerSection.propTypes = {
  title: PropTypes.string.isRequired,
  headerRow: PropTypes.node,
  children: PropTypes.node.isRequired,
};

SrPartnerSection.displayName = 'SrPartnerSection';

export default SrPartnerSection;
